import * as React from 'react';
import LotteryListRenderer from './LotteryListRenderer';


const LotteryListGetter: React.FC<{}> = () => {
    return (
            <LotteryListRenderer />
    )
}
export default LotteryListGetter;